/* eslint-disable import/prefer-default-export */
import getQuery from '../../utilities/query';
import { user } from '../../api';
import { handleError } from '../../utilities/errorHandling';

const queryClient = getQuery();

export const USER_OAUTH_REVOKE = 'user.oauth2.revoke';

queryClient.setMutationDefaults(USER_OAUTH_REVOKE, {
  mutationFn: user.oauthRevoke,
  onError: (error) => {
    handleError(error);
  },
});
